import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';
import * as yup from 'yup';

const config = {
    name: 'sidebar',
    actions: [
        { type: 'request', name: 'getAll' },
        { type: 'request', name: 'getOne' },
        { type: 'request', name: 'create' },
        { type: 'request', name: 'edit' },
        { type: 'request', name: 'delete' },
        { type: 'request', name: 'setActive' }
    ],
    endpoints: {
        sidebars: '/sidebars',
        sidebar: '/sidebars/[id]',
        setActive: '/sidebars/[id]/set-active'
    },
    defaults: {
        createSidebar: {
            name: "",
            definition: { sections: [] },
            active: false
        }
    },
    validations: {
        sidebar: yup.object().shape({
            name: yup.string().required("Numele este obligatoriu"),
            definition: yup.object()
        })
    }
}

const Config = {
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    Defaults: config.defaults,
    Validations: config.validations,
    ...ModuleBootstrapper.getUtils(),
}

export default Config;
